import { useQuery } from '@tanstack/react-query'
import { smartRebalance } from '../../repository/rebalance'
import { EliteLandingPageLoader } from '../../components/elite/landing-page/EliteLandingPageLoader'
import { Navigate, useSearchParams } from 'react-router-dom'
import { StatusResponse } from '../../components/Questionnaire/Stopwatch'

export const EliteLandingPageRBTimer = () => {
  const [searchParams] = useSearchParams()
  const { data, isLoading } = useQuery<any, Error>({
    queryKey: ['SMART_REBALANCE'],
    queryFn: smartRebalance,
    retry: 1,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true
  })

  const isRedirectToRB = () => {
    const rebalanceData = data?.data as StatusResponse
    const timeToRebalancePlanDrop = rebalanceData?.timeToRebalancePlanDrop

    // Check if the time has ended (current time >= timeToRebalancePlanDrop)
    // Convert Date.now() (milliseconds) to seconds (epoch) for comparison
    const currentTimeInMilliSeconds = Math.floor(Date.now())
    const timerHasEnded = currentTimeInMilliSeconds >= timeToRebalancePlanDrop
    if (timeToRebalancePlanDrop) {
      // If timer hasn't ended, return true
      if (!timerHasEnded) {
        return true
      }
      // If timer has ended, continue to check rebalanceAvailable
    }

    // If rebalanceAvailable is true, return true
    if (rebalanceData?.rebalanceAvailable) {
      return true
    }

    // Otherwise return false
    return false
  }

  if (isLoading) return <EliteLandingPageLoader />

  const params = new URLSearchParams(searchParams)
  const queryString = params?.toString() || 'from=APP'

  return isRedirectToRB() ? (
    <Navigate to={`/elite/rb-timer?${queryString}`} replace />
  ) : (
    <Navigate to={`/elite/v5?${queryString}`} replace />
  )
}
